import { useDrop } from "react-dnd";
import useVerticalEvent from "./useVerticalEvent";

const DroppableCell = ({ record, handleDropOnEventCb, allowDropOnSchedular, children }) => {
  const { drop } = useVerticalEvent({ handleDropOnEventCb, record })

  return <div ref={allowDropOnSchedular ? drop : null}>{children}</div>;
};

export default DroppableCell;
